module.exports = __webpack_public_path__ + "static/media/micro.2bed1829.png";